import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Button, message, Spin, Drawer, ConfigProvider, Modal, Input } from 'antd';
import React, { useState } from 'react';
import { post } from '../../../../../axios/axios';
import closeIcon from '../../images/icon_close.svg';
import { converterInstance } from '../../components/AcademicEditor/MarkdownConverter';
import './tableModal.scss';

const TableModal = NiceModal.create(({ orderNo, content, chapterId, from, to, id }) => {
    const modal = useModal();
    const [prompt, setPrompt] = useState('');
    const [loading, setLoading] = useState(false);
    const [newSrc, setNewSrc] = useState('');
    const [tableContent, setTableContent] = useState('');
    const [showConfirm, setShowConfirm] = useState(false);

    const handleOk = async () => {
        modal.resolve({
            content: newSrc,
            from,
            to,
            id,
        });
        modal.hide();
    };

    const onPromptChange = (e) => {
        setPrompt(e.target.value);
    };

    const fetchData = async () => {
        if (!prompt) {
            message.warning('请输入提示词');
            return;
        }

        try {
            setLoading(true);
            const tableMarkdown = content.includes('[AIML_TABLE')
                ? content
                : `[AIML_TABLE id=${id}]${content}[/AIML_TABLE]`;

            const res = await post('/ai/ai/paper/editor/updateChapterTableById', {
                orderNo,
                chapterId,
                prompt,
                id,
                tableContent: tableMarkdown,
            });
            if (res.code === 0) {
                setNewSrc(res.data);
                const htmlContent = converterInstance.makeHtml(res.data);
                setTableContent(htmlContent);
            } else {
                message.error(res.message || '生成失败');
            }
        } catch (error) {
            console.error('Error fetching content reduction:', error);
            message.error('生成失败，请重试');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <ConfigProvider
                theme={{
                    token: {
                        colorBgMask: 'rgba(0, 0, 0, 0.01)',
                    },
                }}
            >
                <Drawer
                    title="修改表格"
                    placement="right"
                    mask={true}
                    maskClosable={true}
                    open={modal.visible}
                    closeIcon={null}
                    destroyOnClose={true}
                    headerStyle={{ borderBottom: 'none' }}
                    bodyStyle={{ padding: '0 24px' }}
                    onClose={() => setShowConfirm(true)}
                    extra={
                        <img
                            className="block h-4 w-4 cursor-pointer"
                            src={closeIcon}
                            onClick={() => setShowConfirm(true)}
                            alt=""
                        />
                    }
                >
                    <div style={{ width: '552px' }}>
                        <div className="flex flex-col gap-4">
                            {/* 提示词输入 */}
                            <div>
                                <div className="title mb-2" style={{ color: '#192038' }}>
                                    提示词
                                </div>
                                <Input.TextArea
                                    className="h-[114px] w-full rounded-md p-3"
                                    style={{
                                        background: '#ffffff',
                                        border: '1px solid #E9E9EA',
                                    }}
                                    placeholder="请尽量详细描述您想要的内容"
                                    maxLength={60}
                                    value={prompt}
                                    onChange={onPromptChange}
                                />
                            </div>

                            {/* 生成按钮 */}
                            {!newSrc && (
                                <Button
                                    type="primary"
                                    onClick={fetchData}
                                    loading={loading}
                                    className="w-full"
                                >
                                    生成表格
                                </Button>
                            )}

                            {/* 生成结果 */}
                            <div className="mt-4">
                                {loading ? (
                                    <div className="flex h-12 w-full items-center justify-center">
                                        <Spin />
                                    </div>
                                ) : tableContent ? (
                                    <div
                                        className="w-full rounded-md p-3"
                                        style={{
                                            background: '#ffffff',
                                            border: '1px solid #9557FF',
                                        }}
                                    >
                                        <div
                                            className="title text-base font-medium"
                                            style={{ color: '#192038' }}
                                        >
                                            生成结果
                                        </div>
                                        <div
                                            className="table-modal content mt-4 rounded border p-4"
                                            dangerouslySetInnerHTML={{ __html: tableContent }}
                                        />
                                    </div>
                                ) : null}
                            </div>

                            {/* 底部按钮 */}
                            {newSrc && (
                                <div className="btns mt-8 flex items-center justify-center">
                                    <Button type="primary" onClick={handleOk}>
                                        替换原文
                                    </Button>
                                    <Button
                                        className="ml-2"
                                        onClick={fetchData}
                                        style={{ background: '#F8FBFF' }}
                                    >
                                        重新生成
                                    </Button>
                                </div>
                            )}
                            {/* <Button type="primary" onClick={handleOk}></Button> */}
                        </div>
                    </div>
                </Drawer>
            </ConfigProvider>

            {/* 关闭确认弹窗 */}
            <Modal
                zIndex={100000}
                title="确认关闭"
                destroyOnClose={true}
                open={showConfirm}
                onOk={() => {
                    setShowConfirm(false);
                    modal.reject();
                    modal.hide();
                }}
                onCancel={() => setShowConfirm(false)}
                okText="确认"
                cancelText="取消"
            >
                <p>确定要关闭当前窗口吗？</p>
            </Modal>
        </>
    );
});

export default TableModal;
